import _ from 'lodash';
import { Metric } from '.';
import { IISearchResultMetricDto, TooltipInfoDto } from '@/repositories/generated/apiClients';

export class AggregateMetric implements IISearchResultMetricDto {
  constructor(
    readonly entityTypeId: string,
    readonly propertyId: string,
    readonly facets: { facetId: string; valueId: string }[],
    public nonsensical: boolean | undefined,
    public tooltipInfo: TooltipInfoDto | undefined
  ) {
    this.type = 'Aggregate';
  }
  type!: string;

  equals(d: Metric): boolean {
    return d instanceof AggregateMetric && d.entityTypeId === this.entityTypeId && d.propertyId === this.propertyId && _.isEqual(this.facets, d.facets);
  }

  toUniqueString(): string {
    return [this.entityTypeId]
      .concat(this.facets.map((f) => `[${f.facetId}:${f.valueId}]`))
      .concat(this.propertyId)
      .join('.');
  }
}
